<template>
  <div class="extra-top-legend">
    <div class="mb-1 row">
      <div class="col value">
        <span class="title">{{ t('bi.total') }}</span>
        <span class="total">{{ totalValue.toLocaleString() }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

//libs
import { useI18n } from 'vue-i18n';

interface Items {
  label: string;
  value: number;
  color: string;
}

interface Props {
  items: Items[];
}

const props = defineProps<Props>();

const { t } = useI18n();

// คำนวณผลรวมของ value
const totalValue = computed(() => {
  return props.items.reduce((sum, item) => sum + item.value, 0);
});
</script>

<style lang="scss" scoped>
.extra-top-legend {
  .row {
    padding-right: 30px;

    .value {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 15px;
      min-width: 0;

      .title {
        font-size: 17px;
        color: #7e7e7e;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis; // พื้นที่แคบให้ตัด title ก่อน ตัวเลขต้องเห็นครบเสมอ
      }
      .total {
        font-size: 25px;
        white-space: nowrap;
        flex: 0 0 auto;
      }
    }
  }
}
</style>
